module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-1.8dd2bcad.svg";